<template>
  <flat-pickr
    :value="value"
    :config="pickerConfig"
    :placeholder="placeholder"
    class="form-control flat-picker vendor-date-picker"
    :disabled="disabled"
    @input="$emit('input', $event)"
  />
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: 'VendorDatePicker',
  components: { flatPickr },
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: 'MM/DD/YYYY' },
    disabled: { type: Boolean, default: false },
    dateFormat: { type: String, default: 'm/d/Y' },
    mode: { type: String, default: 'single' },
    minDate: { type: [String, Date], default: null },
    maxDate: { type: [String, Date], default: null },
  },
  computed: {
    pickerConfig() {
      return {
        mode: this.mode,
        dateFormat: this.dateFormat,
        allowInput: true,
        disableMobile: true,
        static: false,
        minDate: this.minDate || undefined,
        maxDate: this.maxDate || undefined,
      }
    },
  },
}
</script>
